import z from 'zod'
import { centsToEur } from '~/@lib/utils/money.utils'

const withdrawFundsSchema = z
  .object({
    disponibleFunds: z.number(),
    amount: z.number().refine((value) => value > 0, 'Neplatná čiastka'),
  })
  .refine(
    ({ disponibleFunds, amount }) => centsToEur(disponibleFunds) >= amount,
    {
      path: ['amount'],
      message: 'Neplatná čiastka',
    }
  )

const baseWithdrawFundsSchema = z.object({
  isMyAccount: z
    .boolean()
    .refine((value) => value, 'Potvrďte prosím, že účet je Váš'),
  toIban: z
    .string()
    .refine(
      (value) => typeof value === 'string' && value.length > 0,
      'Vyberte prosím účet'
    ),
})

export const formModelSchema = z.intersection(
  withdrawFundsSchema,
  baseWithdrawFundsSchema
)

export type FormModel = Required<z.infer<typeof formModelSchema>>
